/**
 *
 * We'll make it a bit smart by only doing the hotfix if default language is not `en`
 *
 * */

export function googleTranslateHotfix() {
  try {
    if (RUNTIME_ENV === 'native') return;
    const language =
      (window.navigator as any).userLanguage || window.navigator.language;
    if (language.includes('en')) return;

    /**
     * Apply hotfix
     * https://github.com/facebook/react/issues/11538#issuecomment-417504600 */
    if (typeof Node === 'function' && Node.prototype) {
      const originalRemoveChild = Node.prototype.removeChild;
      // eslint-disable-next-line
      // @ts-ignore
      Node.prototype.removeChild = function (child) {
        if (child.parentNode !== this) {
          return child;
        }
        // eslint-disable-next-line
        return originalRemoveChild.apply(this, arguments as any);
      };

      const originalInsertBefore = Node.prototype.insertBefore;

      // eslint-disable-next-line
      // @ts-ignore
      Node.prototype.insertBefore = function (newNode, referenceNode) {
        if (referenceNode && referenceNode.parentNode !== this) {
          return newNode;
        }
        // eslint-disable-next-line
        return originalInsertBefore.apply(this, arguments as any);
      };
    }
  } catch (e) {}
}
